
export const VERIFY_OTP_NUMBER_SUCCESS = "VERIFY_OTP_NUMBER_SUCCESS"

export const API_ERROR = "AUTH_API_ERROR"

export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS"

export const CREATE_USER = "CREATE_USER"

export const VERIFY_OTP_NUMBER = "VERIFY_OTP_NUMBER"

export const RESEND_OTP_NUMBER = "RESEND_OTP_NUMBER"

export const GET_ACCOUNT_INFO = "GET_ACCOUNT_INFO"